module.exports = __webpack_public_path__ + "static/img/diease-left-name.765a4581.png";